import { render } from "./adminScreen.vue?vue&type=template&id=30b4a766&scoped=true"
import script from "./adminScreen.vue?vue&type=script&lang=js"
export * from "./adminScreen.vue?vue&type=script&lang=js"

import "./adminScreen.vue?vue&type=style&index=0&id=30b4a766&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30b4a766"]])

export default __exports__